const NoPage = (props) => {
    return (
        <>404 Not Found</>
    )
}

export default NoPage